module.exports = __webpack_public_path__ + "static/media/contact.0910ce32.svg";